import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { LocalStorageService } from '../service/local-storage.service';
import { LocalStorageEnum } from '../../shared/enum.ts/local-storage.enum';
import { Role } from '../../shared/enum.ts/role.enum';

/**
 * Allows only `SUPER_ADMIN` users. Used by surfaces such as the
 * soft-deleted users list. Sibling to {@link adminGuard}, which
 * permits both `SUPER_ADMIN` and `STORE_ADMIN`.
 */
export const superAdminGuard: CanActivateFn = () => {
  const localStorageService = inject(LocalStorageService);
  const router = inject(Router);
  const user = localStorageService.getItem(LocalStorageEnum.USER);

  if (user && user.roleName === Role.SUPER_ADMIN) {
    return true;
  }
  router.navigate(['/']);
  return false;
};
